import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../js/stores/language.js';
import user from '../../js/stores/user.js';
import * as dayjs from 'dayjs';
import validator from 'validator';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $f7router = _ref.$f7router,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var calendarDefault;
  var maxPoints = 50;
  var strongPassConfig = {
    minLength: 8,
    minLowercase: 1,
    minUppercase: 1,
    minNumbers: 1,
    minSymbols: 1,
    returnScore: true,
    pointsForContainingLower: 10,
    pointsForContainingUpper: 10,
    pointsForContainingNumber: 10,
    pointsForContainingSymbol: 10
  };
  var updatePassword = function updatePassword(e) {
    var result = validator.isStrongPassword(e.target.value, strongPassConfig);
    var x = result * 100 / maxPoints;
    $f7.progressbar.set('#password-force', x);
    $update();
  };
  var goAddNewUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var formData, isEmpty, setFocus, allowedFields, key, extraDriverAge, timeElapsed, today, diffAgeToday, created, _t, _t2, _t3;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            formData = $f7.form.convertToData('#user-form-create');
            isEmpty = false;
            setFocus = '';
            allowedFields = {
              "user-name": formData.UserName,
              "user-email": formData.UserEmail,
              "user-password": formData.UserPassword,
              "user-password-confirm": formData.UserPasswordConfirm
            };
            _t = _regeneratorRuntime.keys(allowedFields);
          case 1:
            if ((_t2 = _t()).done) {
              _context.next = 3;
              break;
            }
            key = _t2.value;
            if (!validator.isEmpty(allowedFields[key])) {
              _context.next = 2;
              break;
            }
            isEmpty = true;
            setFocus = key;
            return _context.abrupt("continue", 3);
          case 2:
            _context.next = 1;
            break;
          case 3:
            if (!isEmpty) {
              _context.next = 4;
              break;
            }
            $f7.toast.show({
              text: locale.translate('user.newAccount.userMissingFieldsMessage')
            });
            document.getElementById(setFocus).focus();
            return _context.abrupt("return");
          case 4:
            if (checkUserName()) {
              _context.next = 5;
              break;
            }
            return _context.abrupt("return");
          case 5:
            if (checkUserEmail()) {
              _context.next = 6;
              break;
            }
            return _context.abrupt("return");
          case 6:
            if (checkUserPassword()) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            if (checkUserPasswordConfirm()) {
              _context.next = 8;
              break;
            }
            return _context.abrupt("return");
          case 8:
            extraDriverAge = calendarDefault.value;
            timeElapsed = Date.now();
            today = new Date(timeElapsed);
            diffAgeToday = dayjs(today).diff(extraDriverAge, 'y');
            if (!(diffAgeToday < 21)) {
              _context.next = 9;
              break;
            }
            $f7.toast.show({
              text: locale.translate('user.edit.personal.contactNotAdultMessage')
            });
            return _context.abrupt("return");
          case 9:
            if (document.getElementById('user-acceptance-agreement').checked) {
              _context.next = 10;
              break;
            }
            $f7.toast.show({
              text: locale.translate('user.newAccount.userAcceptAgreementMessage')
            });
            document.getElementById('user-acceptance-agreement').focus();
            return _context.abrupt("return");
          case 10:
            _context.next = 11;
            return user.dispatch('createAccount', formData);
          case 11:
            created = _context.sent;
            if (!(created.status !== undefined && created.status !== 201)) {
              _context.next = 12;
              break;
            }
            $f7.toast.show({
              text: created.data.messages.error
            });
            return _context.abrupt("return");
          case 12:
            $f7.views.main.router.navigate('/');
            $f7.toast.show({
              text: locale.translate('user.newAccount.userSuccesfullyCreatedMessage'),
              closeTimeout: 4000
            });
            return _context.abrupt("return");
          case 13:
            _context.prev = 13;
            _t3 = _context["catch"](0);
            console.error(_t3);
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 13]]);
    }));
    return function goAddNewUser() {
      return _ref2.apply(this, arguments);
    };
  }();
  var checkUserName = function checkUserName() {
    var formData = $f7.form.convertToData('#user-form-create');
    if (formData.UserName.length < 8) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userMinLengthMessage')
      });
      return false;
    }
    return true;
  };
  var checkUserEmail = function checkUserEmail() {
    var formData = $f7.form.convertToData('#user-form-create');
    if (!validator.isEmail(formData.UserEmail)) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userEmailValidMessage')
      });
      return false;
    }
    return true;
  };
  var checkUserPassword = function checkUserPassword() {
    var formData = $f7.form.convertToData('#user-form-create');
    var result = validator.isStrongPassword(formData.UserPassword, strongPassConfig);
    if (result < 25) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userPasswordValidationsMessage'),
        closeTimeout: 4000
      });
      return false;
    }
    return true;
  };
  var checkUserPasswordConfirm = function checkUserPasswordConfirm() {
    var formData = $f7.form.convertToData('#user-form-create');
    if (!validator.equals(formData.UserPassword, formData.UserPasswordConfirm)) {
      $f7.toast.show({
        text: locale.translate('user.newAccount.userPasswordMismatchMessage')
      });
      return false;
    }
    return true;
  };
  var showBirthCalendar = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            calendarDefault.open();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function showBirthCalendar() {
      return _ref3.apply(this, arguments);
    };
  }();
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          calendarDefault = $f7.calendar.create({
            inputEl: '#driver-contact-birth-date',
            openIn: 'customModal',
            dateFormat: 'yyyy-mm-dd',
            header: true,
            footer: true,
            closeOnSelect: true,
            headerPlaceholder: locale.translate('user.edit.personal.contactBirthDateLabel'),
            toolbarCloseText: locale.translate('general.done'),
            on: {
              closed: function closed(e) {
                if (e.value === undefined) return;
                var rangeDates = e.value;
                var startDate = dayjs(rangeDates[0]).format('YYYY-MM-DD');
                document.getElementById("driver-contact-birth-date").value = "".concat(startDate);
              }
            }
          });
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })));
  $on('pageBeforeRemove', function () {
    calendarDefault.destroy();
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="user-new">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('user.newAccount.titleDialog')}</div>
    </div>
  </div>
  <div class="page-content login-screen-content">
    <div class="block">
      <div class="block-title">${locale.translate('user.newAccount.titleForm')}</div>
      <form id="user-form-create" class="list no-hairlines-md">
        <ul>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div id="" class="item-title item-label">${locale.translate('user.newAccount.userNameLabel')}</div>
                <div id="label" class="item-title item-label"></div>
                <div class="item-input-wrap">
                  <input id="user-name" name="UserName" type="text" placeholder="${locale.translate('user.newAccount.userNamePlaceHolder')}" autocomplete="off" @blur="${checkUserName}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${locale.translate('user.newAccount.userEmailLabel')}</div>
                <div class="item-input-wrap">
                  <input id="user-email" name="UserEmail" type="email" placeholder="${locale.translate('user.newAccount.userEmailPlaceholder')}" autocomplete="off" @blur="${checkUserEmail}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${locale.translate('user.newAccount.userPasswordLabel')}</div>
                <div class="item-input-wrap">
                  <input id="user-password" name="UserPassword" type="password" autocomplete="off" @input="${updatePassword}" @blur="${checkUserPassword}"
                    placeholder="${locale.translate('user.newAccount.userPasswordPlaceholder')}. ${locale.translate('user.newAccount.userPasswordAllowedCharsMessage')}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="block block-strong-ios block-outline-ios">
              <div id="password-force" class="progressbar color-green"></div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${locale.translate('user.newAccount.userPasswordConfirmLabel')}</div>
                <div class="item-input-wrap">
                  <input id="user-password-confirm" name="UserPasswordConfirm" type="password" placeholder="${locale.translate('user.newAccount.userPasswordConfirmPlaceHolder')}" 
                  autocomplete="off" @blur="${checkUserPasswordConfirm}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">${locale.translate('user.edit.personal.contactBirthDateLabel')}</div>
                <div class="item-input-wrap">
                  <input id="driver-contact-birth-date" name="UserBirthDate" type="text" readonly="readonly" @click="${showBirthCalendar}"
                    placeholder="${locale.translate('user.edit.personal.contactBirthDateLabel')}"/>
                </div>
              </div>
            </div>
          </li>
          <li>
            <label class="item-checkbox item-content">
              <input id="user-acceptance-agreement" name="UserAcceptanceAgreement" type="checkbox" />
              <i class="icon icon-checkbox"></i>
              <div class="item-inner">
                <div class="item-title">
                  ${locale.translate('user.newAccount.userAgreementCheckbox')} <br />
                  <a href="/static/docs/DeLeenAuto-Agreement.pdf" class='external link text-align-left' target="_system">${locale.translate('user.newAccount.userAgreementViewDoc')}</a>
                </div>
              </div>
            </label>
          </li>
        </ul>
      </form>
      <div class="block block-strong">
        <p class="grid grid-cols-2">
          <a href="#" class="button button-small button-fill back">${locale.translate('general.close')}</a>
          <a href="#" class="button button-small button-fill button-raised color-green" @click="${goAddNewUser}">${locale.translate('general.save')}</a>
        </p>
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '8629102b67';
export default framework7Component;